import { makeAutoObservable } from "mobx"

export default class CampaignContact {

  constructor(campaignContact={}) {
    this.id = campaignContact.id
    this.name = campaignContact.name || ''
    this.phone = campaignContact.phone || ''
    this.email = campaignContact.email || ''
    this.notes = campaignContact.notes || ''
    this.file = null
    this.avatar = campaignContact.avatar


    makeAutoObservable(this)
  }
}
